import i18n from 'shared/lib/i18n';

import ViewExportContainer from '../ViewExport/ViewExportContainer';

import { formatDate } from '../../utils';
import { getFullName } from '../Person/utils';

const getTableData = (data, columns) => {
  const headers = columns
    .filter(({ id }) => id !== 'actions')
    .map(({ Header }) => Header);
  const rows = [];
  data.forEach(
    ({
      type,
      accessCardBatchName,
      number,
      scanCode,
      effectiveDate,
      validUntil,
      person,
      syncedWithAcs,
      creator,
    }) => {
      const isSyncedWithAcs = syncedWithAcs
        ? i18n.t('common.yes')
        : i18n.t('common.no');

      rows.push([
        type,
        accessCardBatchName,
        number,
        scanCode,
        formatDate(effectiveDate),
        formatDate(validUntil),
        getFullName(person),
        isSyncedWithAcs,
        getFullName(creator),
        creator?.roleName ?? i18n.t('common.NR'),
      ]);
    },
  );
  return { headers, rows };
};

const AccessCardsListExport = (props) => (
  <ViewExportContainer {...props} getTableData={getTableData} />
);

export default AccessCardsListExport;
